import React from "react";
import { useLoaderData, Await } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { CMAddressBook, GetCampaignsListResponse } from "services/apiService";
import Box from '@mui/material/Box';
import CampaignsDatagrid from 'views/campaign/CampaignsDatagridVERSION2';
import Typography from '@mui/material/Typography';
import BACKUPDATAGRID from "views/campaign/BACKUP-CAMPAIGN-DATAGRID";

export enum HomeAction {
    DeleteContacts = "DELETE_CONTACTS",
    AddContact = "ADD_CONTACTS",
    ScheduleCampaing = "SCHEDULE_CAMPAING"
}

const SentCampaign = () => {
    const loaderData = useLoaderData() as {
        data: Promise<[GetCampaignsListResponse, CMAddressBook[]]>;
    };

    return (
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading campaigns and addressBooks data...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.data}
                errorElement={<p>No rows</p>}
            >
                <Typography variant="h4">
                    <span>Sent Campaings</span>
                </Typography>
                <br />
                <BACKUPDATAGRID cm_status={"sent"} />
            </Await>
        </React.Suspense>
    );
};

export default SentCampaign;